<ion-header>
  <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button (click)="cancel()"><ion-icon slot="start" name="close"></ion-icon></ion-button>
      </ion-buttons>
      <ion-title class="ion-text-center">Email Ändern</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
<div class="ion-padding">
  <form id="accountForm" [formGroup]="emailChangeForm" (ngSubmit)="onChangeEmail()" novalidate>
    <ion-list>
      <ion-item>
        <ion-input label="Aktuelles Passwort" labelPlacement="stacked" type="password" autofocus="true" autocomplete="password" inputmode="password" name="current_password" formControlName="current_password"></ion-input>
      </ion-item>
      <ion-item>
        <ion-input label="Neue Email Addresse" labelPlacement="stacked" type="email" autocomplete="email" name="new_email" formControlName="new_email"></ion-input>
      </ion-item>
    </ion-list>
    <ion-button type="submit" size="block" [disabled]="!emailChangeForm.dirty || emailChangeForm.invalid">Email ändern</ion-button>
  </form>
</div>
</ion-content>
